module.exports = __webpack_public_path__ + "img/calhoun-911-logo.76e0fce6.jpg";